import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Obtener el token desde sessionStorage
        const sesion = sessionStorage.getItem('segurito') || '';
        let authToken = null;
        if(sesion != '') {
            authToken = JSON.parse(atob(sesion));  // Asegúrate de que la clave sea la correcta
        }
        // Si el token existe, clonamos la solicitud y agregamos la cabecera Authorization
        if (authToken && authToken['t']) {
            // let headerName = authToken['headerName'];
            const clonedRequest = req.clone({
                headers: req.headers.set(authToken['headerName'], `Bearer ${authToken['t']}`)
                // setHeaders: {
                //     headerName: `Bearer ${authToken['t']}`
                // }
            });

            // Pasar la solicitud modificada al siguiente interceptor o al servidor
            return next.handle(clonedRequest);
        }

        // Si no hay token, simplemente pasamos la solicitud sin modificar
        return next.handle(req);
    }
}